import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useStatusOverlay } from '@fs/zion-ui'
import getKiosk from '../../helpers/getKiosk'
import { kioskInitialState, kioskReducer, ACTIONS } from './useKioskReducer'
import { useDSCDispatch, ACTIONS as DSC_ACTIONS } from '../../../../state/DSCStore'
import cleanupCenterUser, { updateLanguage } from '../../../../shared/helpers/sessionCleanup'

const useKiosk = ({ listenForDock = false, listenForUndock = false }) => {
  const [state, dispatch] = React.useReducer(kioskReducer, kioskInitialState)
  const rootDispatch = useDSCDispatch()
  const showStatusOverlay = useStatusOverlay()
  const { color, redirect, unauthRedirect, keyCodeUndockRedirect } = state
  const location = useLocation()
  const { app: appFromNav } = location.state ?? {}

  useEffect(() => {
    if (listenForDock || listenForUndock) {
      getKiosk(appFromNav).then((kioskData) => {
        dispatch({
          type: ACTIONS.INIT_KIOSK,
          data: { ...kioskData },
        })

        // Show warning overlay if center code was invalid
        if (kioskData.invalidCenterWarning) {
          showStatusOverlay({
            message: kioskData.invalidCenterWarning,
            type: 'warning',
          })
        }
      })
    }
  }, [listenForDock, listenForUndock, appFromNav, showStatusOverlay])

  const activateKiosk = ({ userDetails }) => {
    rootDispatch({
      type: DSC_ACTIONS.POPULATE_NONSTANDARD_USER,
      data: { nonstandardUser: { ...userDetails } },
    })

    updateLanguage(userDetails.language)
  }

  const leaveKiosk = () => {
    cleanupCenterUser()
    window.location = `${keyCodeUndockRedirect}`
  }

  return {
    color,
    redirect,
    unauthRedirect,
    activateKiosk,
    leaveKiosk,
  }
}
export default useKiosk
